

// store/index.js
import { createStore } from 'vuex'
import chat from './chat'

export default createStore({
    modules: {
        chat
    }
})

// // 存储数据到 localStorage
// // localStorage.setItem('myKey', JSON.stringify(myData));
//
// // 从 localStorage 获取数据
// // const myData = JSON.parse(localStorage.getItem('myKey'));
//
// // 当前用户信息
// const storageData = {
//     recent_userList:JSON.parse(localStorage.getItem('recent_userList')),
//     allChat_recordList:JSON.parse(localStorage.getItem('allChat_recordList')),
// };
// export default {
//     state: {
//         "recent_userList":storageData.recent_userList||[],// 最近聊天的用户
//         "allChat_recordList":storageData.allChat_recordList||{},// 所有聊天记录
//     },
//     mutations:{
//         // 数据修改
//         chat_setData(state,[key,value]) {
//             console.log("【thisUser】的store做setData操作",key,value);
//             state[key] = value;
//             if(['recent_userList','allChat_recordList'].includes(key)){
//                 // 转JSON 存储缓存
//                 localStorage.setItem(key, JSON.stringify(value));
//             }
//         },
//         // 多数据修改
//         chat_setManyData(state,objData){
//             for (let key in objData) {
//                 this.commit('chat_setData',[key,objData[key]])
//             }
//         },
//
//         // 发送数据 并存储聊天记录
//         vuex_addMessage(state,objData){
//             let this_recordList = state['allChat_recordList'][objData['userPhone']];
//             console.error(this_recordList)
//         },
//         // 存储好友列表
//         vuex_setRecentUserList(state,[key,value]){
//             state[key] = value;
//         }
//     },
//     getters:{
//         recent_userList:data=>data.recent_userList,// 最近聊天的用户
//         allChat_recordList:data=>data.userInfo,
//     }
// }
//
//
//
// // // store/index.js
// // import { createStore } from 'vuex'
// //
// // // 定义状态
// // const state = {
// //     count: 0
// // }
// //
// // // 定义 mutations
// // const mutations = {
// //     increment (state) {
// //         state.count++
// //     }
// // }
// //
// // // 定义 actions
// // const actions = {
// //     increment ({ commit }) {
// //         commit('increment')
// //     }
// // }
// //
// // // 创建并导出 store
// // export default createStore({
// //     state,
// //     mutations,
// //     actions
// // })
// //
// //
// // // import Vue from 'vue'
// // // import Vuex from 'vuex'
// // //
// // // import chat from './chat'
// // //
// // // Vue.use(Vuex);//vue的插件机制
// // //
// // // //Vuex.Store 构造器选项
// // // const store = new Vuex.Store({
// // //
// // //     state:{},//存放状态
// // //     modules: {
// // //         device,// 当前设备与环境
// // //         appCache,// 应用缓存
// // //         thisUser,// 当前用户信息
// // //         appVersion,// 当前App版本信息
// // //     },
// // //
// // //     // state:{},//存放状态
// // //     // mutations:{
// // //     //     // 数据修改
// // //     //     setData(state,[key,value]) {
// // //     //         console.error("store做setData操作",key,value);
// // //     //         state[key] = value;
// // //     //     },
// // //     //     // 多数据修改
// // //     //     setManyData(state,objData){
// // //     //         for (let key in objData) {
// // //     //             this.commit('setData',[key,objData[key]])
// // //     //         }
// // //     //     }
// // //     // },
// // //     // actions: {// 异步
// // //     //     getDiyTopNav({ commit }, userInfo) {
// // //     //         // 请求登录接口
// // //     //         // ...
// // //     //
// // //     //         // 更新用户信息
// // //     //         commit('setUserInfo', userInfo)
// // //     //     }
// // //     // },
// // //
// // //     // getters: {// 类似于计算属性
// // //     //     token:data=>data.thisUser.token,
// // //     //     userInfo:data=>data.thisUser.userInfo,
// // //     // }
// // // });
// // // export default store
